var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.$vuetify.breakpoint.xs ? 'mx-2' : 'mx-8',style:(_vm.showSubmenu !== false ? 'padding-top:100px' : 'padding-top:1rem')},[_c('BirdDogDashboardView')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }